import React, { useState } from 'react'
import {
  Alert,
  Box,
  CircularProgress,
  Pagination,
  Tab,
  Tabs,
  Typography,
} from '@mui/material'
import { Offers } from 'components'
import useSWR from 'swr'
import api from 'utils/api'
import OfferDisplayToggle from 'components/offers/OfferDisplayToggle'
import useOfferDisplayMode from 'components/offers/useOfferDisplayMode'
import AccountPage from '../../components/AccountPage'
import AccountPageIntro from '../../components/AccountPageIntro'

const FavoritePageContainer = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [activeOnly, setActiveOnly] = useState(true)
  const [listMode, setListMode] = useOfferDisplayMode()
  const apiRoute = `/favorite?active=${activeOnly}&size=12&page=${currentPage - 1}`
  const { data: offers, error, mutate } = useSWR(apiRoute, () => api.get(apiRoute), {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnMount: true,
  })

  const handleAvailabilityChange = (_event, value) => {
    setActiveOnly(value === 'available')
    setCurrentPage(1)
  }

  return (
    <AccountPage title="Favorites">
      <Box
        px={{ xs: 2, md: 3 }}
        mb={0.5}
      >
        <AccountPageIntro
          action={<OfferDisplayToggle displayMode={listMode} onChange={setListMode} />}
        >
          Offers you have saved for later.
        </AccountPageIntro>
        <Tabs
          aria-label="Favorite offer availability"
          onChange={handleAvailabilityChange}
          value={activeOnly ? 'available' : 'unavailable'}
          sx={{
            minHeight: 34,
            width: 'fit-content',
            '& .MuiTabs-flexContainer': { gap: 2 },
            '& .MuiTabs-indicator': {
              borderRadius: 2,
              height: 2,
            },
            '& .MuiTab-root': {
              fontWeight: 500,
              minHeight: 34,
              minWidth: 'auto',
              px: 0.5,
              py: 0.5,
              textTransform: 'none',
              whiteSpace: 'nowrap',
            },
            '& .MuiTab-root.Mui-selected': {
              color: 'primary.main',
              fontWeight: 600,
            },
          }}
        >
          <Tab label="Available" value="available" sx={{ fontSize: 14 }} />
          <Tab label="Unavailable" value="unavailable" sx={{ fontSize: 14 }} />
        </Tabs>
      </Box>
      <Box px={2} pt={1} pb={2}>
        {error ? (
          <Alert severity="error">Your favorite offers could not be loaded. Try again later.</Alert>
        ) : !offers ? (
          <Box p={4} display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : offers.content.length ? (
          <Offers
            columns={4}
            offers={offers.content}
            offerOrigin="favorite"
            offerType={listMode}
            revalidateList={mutate}
          />
        ) : (
          <Typography paragraph>
            {activeOnly
              ? "You don't have any available favorites."
              : "You don't have any unavailable favorites."}
          </Typography>
        )}
        {!error && offers?.totalPages > 1 && (
          <Box display="flex" justifyContent="center" pt={4}>
            <Pagination page={currentPage} count={offers.totalPages} onChange={(e, newPage) => setCurrentPage(newPage)} color="primary" />
          </Box>
        )}
      </Box>
    </AccountPage>
  )
}

export default FavoritePageContainer
